import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=95a7356c"
import script from "./PaymentLink.vue?vue&type=script&lang=js"
export * from "./PaymentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports